// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'server';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9 7.344h1.152m2.232 0h2.232m2.808 0c0 .864-.36 1.728-1.008 2.376a3.388 3.388 0 0 1-2.376 1.008H3.96c-.864 0-1.728-.36-2.376-1.008C.936 9.072.576 8.208.576 7.344s.36-1.728 1.008-2.376C2.16 4.32 3.024 3.96 3.96 3.96h10.152c.864 0 1.728.36 2.376 1.008.576.576.936 1.44.936 2.376zM9 14.04h1.152m2.232 0h2.232' />
    <path d='M17.424 14.04c0 .864-.36 1.728-1.008 2.376s-1.512 1.008-2.376 1.008H3.96c-.864 0-1.728-.36-2.376-1.008S.576 14.904.576 14.04s.36-1.728 1.008-2.376 1.512-1.008 2.376-1.008h10.152c.864 0 1.728.36 2.376 1.008.576.648.936 1.512.936 2.376z' />
    <path d='M4.248 14.328c-.144 0-.288-.144-.288-.288s.144-.288.288-.288m0 .576c.144 0 .288-.144.288-.288s-.144-.288-.288-.288m0-6.192c-.144 0-.288-.144-.288-.288s.144-.288.288-.288m0 .576c.144 0 .288-.144.288-.288s-.144-.288-.288-.288m12.888-1.08-1.872-4.032c-.216-.36-.504-.72-.864-.936a2.427 2.427 0 0 0-1.224-.36H4.824c-.432 0-.864.144-1.224.36s-.648.504-.864.936L.864 5.904' />
  </g>
);

export const viewBox = '0 0 18 18';
